export default __webpack_public_path__ + "static/media/mastercard.541b988c.svg";